import * as React from "react";
import Button from "@mui/material/Button";
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { logger, customBodyForExcelReport, handleExport, checkAuthentication, muiLoaderOptions } from '../../utils';
import { muiThemeDesign } from '../../mui-theme-design';
import { MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import { Box } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

const ExcelJS = require('exceljs');

export default function InvoiceMonthlyReport() {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [openReport, setOpenReport] = React.useState(false);
    const [month, setMonth] = React.useState(moment());
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [LockedAlert, setAlert] = React.useState(false);
    const [invoiceData, setInvoiceData] = React.useState([]);
    const [overTime, setsOverTime] = React.useState([])
    const [expand, setExpand] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [showUnBilled, setShowUnBilled] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    
    React.useEffect(() => {
        if (refresh) {
			handleMonth(moment());
            setRefresh(false);
        }
    })

	const handleMonth = (Data) => {
		setMonth(Data);
		const date = new Date(Data);
		const year = date.getFullYear();
		const month = date.getMonth() + 1;

		// Start date is always the first day of the current month
		const start = `${year}-${month.toString().padStart(2, '0')}-01`;

		// Calculate the end date by handling December 
		const nextMonth = month === 12 ? 1 : month + 1;
		const nextYear = month === 12 ? year + 1 : year;
		const end = `${nextYear}-${nextMonth.toString().padStart(2, '0')}-01`;
		setStartDate(start);
		setEndDate(end);
	};

    
    const handleClickOpen = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false);
        //setExpand(false);
    };
    
    const handleReportClose = () => {
        setOpenReport(false);
        setExpand(false);
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };
    
    const handleGenerate = async (download) => {
        await fetch(`/api/BilledInvoiceMonthly/${startDate}/${endDate}/${showUnBilled}`, {
                method: 'Get',
            })
            .then(res => res.json())
            .then(json => {
                if (json.length===0){
                    setOpenReport(false);
                    setAlertText("No Invoices available within the selected period");
                    setAlert(true);
                } else {
                    if(!download) {
                        setOpenReport(true);
                        setInvoiceData(json);
                    } else { // download button selected
                        let dataSet = json;
                        downloadFile(dataSet);
                    }
                }
            })
		setIsLoading(false);
        //handleClose();
    };
    
    const applyDiscount = (invoice, price) => {
        let discount = invoice.DiscountRate
        if(discount[discount.length-1] === "%") {
            discount = discount.slice(0, -1);
        }
        var getPrice = discount / 100;
  		var totalValue = price - (price * getPrice)
        logger(totalValue.toFixed(2));
        return parseFloat(totalValue).toFixed(2);
    }
     
    const calculateRate = (rate, item) => {
        if (item) {
            if (item.flagType === 'OT') {
                return rate * item.OverTimeWeek;
            } else if (item.flagType === 'WND') {
                return rate * item.OverTimeWeekEnd;
            } else if (item.flagType === 'HOL') {
                return rate * item.OverTimeHoliday;
            } else {
                return rate;
            }
        } else {
            return 0;
        }
    };
     
    
    const getTotal = (item) => {
        let total = 0;

        // Check if item.Rate exists and has a 'data' property
        if (item.Rate && item.Rate.data) {
            const byteArray = new Uint8Array(item.Rate.data);
            const textDecoder = new TextDecoder();
            const res = textDecoder.decode(byteArray);
            const r = parseFloat(res).toFixed(2);
            let num = calculateRate(r, item);
            total += num * item.Hours;
        } else {
            logger('Error: item.Rate or item.Rate.data is null or undefined', item);
        }

        return total.toFixed(2);
    };

    const grandTotal = (invoice, Labor, Expense) => {
	    let res;
        if (Expense>0) {
			const discountedLabor = applyDiscount(invoice, parseFloat(Labor).toFixed(2));
			let tmpTotal = parseFloat(discountedLabor) + parseFloat(Expense)
            logger("tmpTotal",tmpTotal)
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT with Exp`, res)
            return res;
        } else {
            const tmpTotal = applyDiscount(invoice, parseFloat(Labor).toFixed(2))
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT no Exp`, res)
            return res;
        }
    }

    const downloadFile = async (dataset) => {
        
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        if (dataset) {
            // var dynamicColumns = [];
            // if(expand === "detailed") {
            //     taskVariable.forEach((e) => {
            //         dynamicColumns.push(e.Name);
            //     });
            // } else if(expand === "summary") {
            //     dynamicColumns.push("Task Variables");
            // }
            
            
            var columnsIncludeInSheet = ["Invoice Number", "Invoice Start Date", "Invoice End Date", "PO Name", "PO Number", "Raw Labor", "Discount Rate",
                                         "Discounted Labor", "Expense Total", "Calculated Invoice Amount", "Invoice Amount", "Cost Center Number", "Owner",
                                         "Owner Email", "Email Group", "Bill To", "Ship To"];
            var matchingColumnsFromDataset = ["InvoiceNumber", "StartDate", "EndDate", "PoName", "PoNumber", "getTotal", "DiscountRate", "applyDiscount", "ExpenseTotal",
                                         "Calculated Invoice Amount", "InvoiceAmount", "CostCenter", "Owner", "Email", "EmailGroup", "BillTo", "ShipTo"];
        
            // columnsIncludeInSheet = columnsIncludeInSheet.concat(dynamicColumns);
            // matchingColumnsFromDataset = matchingColumnsFromDataset.concat(dynamicColumns);
            
            // Set up column headers with bold font
            const headerRow = worksheet.addRow(columnsIncludeInSheet);
            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
            });
            worksheet.autoFilter = {
                from: 'A1',
                to: 'AD', 
            };

            dataset.forEach((item, dataIndex) => {
                const row = [];
                const total = getTotal(item);
                const grandTotalVal = grandTotal(item, total, item.ExpenseTotal);
                for (let i = 0; i < matchingColumnsFromDataset.length; i++) {
                    const columnKey = matchingColumnsFromDataset[i];

                    if (columnsIncludeInSheet[i] === "Invoice Start Date" || columnsIncludeInSheet[i] === "Invoice End Date") {
                        item[columnKey] = moment.utc(item[columnKey]).format("MM/DD/YYYY");
                    } else if (columnsIncludeInSheet[i] === "Discount Rate") {
                        item[columnKey] = item.DiscountRate + "%";
                    } else if (columnsIncludeInSheet[i] === "Raw Labor") {
                        item[columnKey] = total;
                    } else if (columnsIncludeInSheet[i] === "Discounted Labor") {
                        let discountTotal = applyDiscount(item, total);
		                item[columnKey] = discountTotal;
                    } else if(columnsIncludeInSheet[i] === "Expense Total") {
                        let expenseTotal = item.ExpenseTotal;
					    item[columnKey] = expenseTotal && expenseTotal > 0 ? '$' + expenseTotal : expenseTotal;
                    } else if(columnsIncludeInSheet[i] == "Calculated Invoice Amount") {
                        let calcTotal = grandTotalVal;
					    item[columnKey] = calcTotal;
                    }
                    row.push(item[columnKey]);
                }

                //worksheet.addRow(Object.values(item));
                const currRow = worksheet.addRow(row);
                currRow.eachCell((cell, colNumber) => {
                    if (columnsIncludeInSheet[colNumber-1] === "Invoice Amount") {
					    if( grandTotalVal != item.InvoiceAmount) {
                            cell.font = { color: { argb: 'eb4034' } };
                        }
                    }
                });
            });

            columnsIncludeInSheet.forEach((header, index) => {
                let headerLength = header ? header.length : 0; // Handle header if undefined
                headerLength = headerLength * 1.1; // Account for larger bold letters
                var maxColumnWidth = worksheet.getColumn(index + 1).values.reduce((maxWidth, value) => {
                    if (value && value.length > maxWidth) {
                        return value.length;
                    }
                    return maxWidth;
                }, 0);

                if (maxColumnWidth > 40) {
                    maxColumnWidth = 40;
                }
                worksheet.getColumn(index + 1).width = Math.max(headerLength, maxColumnWidth) + 2;
                worksheet.getColumn(index + 1).alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
            });

            // setIsDownloading(false);

            // Generate the Excel file as a Blob
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const currentDate = moment.utc().format("yyyy-MM-DD");
            link.href = url;
            link.download = currentDate + "_MonthlyInvoiceReport.xlsx";
            link.click();
            URL.revokeObjectURL(url);
        } else {
            // setIsDownloading(false);
            logger("No data available to download.");
        }
    };
    
    const columns = [
        {
            name: "InvoiceNumber",
            label: "Invoice Number",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Invoice StartDate",
            options: {
                filter: true,
                sort: true,
                 customBodyRenderLite: (dataIndex, rowIndex) => {
                const startDate = moment.utc(invoiceData[dataIndex].StartDate).format('MM-DD-YYYY');
                return startDate;
            }
            }
        },
         {
            name: "EndDate",
            label: "Invoice EndDate",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                const endDate = moment.utc(invoiceData[dataIndex].EndDate).format('MM-DD-YYYY');
                return endDate;
            }
            }
        },
        {
            name: "PoName",
            label: "PoName",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "PoNumber",
            label: "PONumber",
            options: {
                filter: true,
                sort: true,
            }
        },
		{
            name: "getTotal",
            label: "Raw Labor",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    var total = getTotal(invoiceData[dataIndex]);
                    return total && total > 0 ? '$' + total : total;
                }
			}
		},
        {
            name: "DiscountRate",
            label: "Discount Rate",
            options: {
                filter: true,
                sort: true,
                 customBodyRenderLite: (dataIndex, rowIndex) => {
					 var discount = invoiceData[dataIndex].DiscountRate;
		            return discount && discount > 0 ? discount + '%' : discount;
		        }
                 
            }
        },
        {
            name: "applyDiscount",
            label: "Discounted Labor",
            options: {
                filter: true,
                sort: true,
                 customBodyRenderLite: (dataIndex, rowIndex) => {
					 var total = applyDiscount(invoiceData[dataIndex], getTotal(invoiceData[dataIndex])); 
		            return total && total > 0 ? '$' + total : total;
		        }
                 
            }
        },
        {
			name: "ExpenseTotal",
			label: "Expense Total",
			options: {
				filter: true,
				sort: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					var total = invoiceData[dataIndex].ExpenseTotal;
					return total && total > 0 ? '$' + total : total;
				}

			}
        },
        {
            name: "Calculated Invoice Amount",
            label: "Calculated Invoice Amount",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    var total = grandTotal(invoiceData[dataIndex], getTotal(invoiceData[dataIndex]), invoiceData[dataIndex].ExpenseTotal);
                    return total && total > 0 ? '$' + total : total;
                }
            }
        },
        {
            name: "InvoiceAmount",
            label: "Invoice Amount",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const invoiceTotal = invoiceData[dataIndex].InvoiceAmount;
                    const total = grandTotal(invoiceData[dataIndex], getTotal(invoiceData[dataIndex]), invoiceData[dataIndex].ExpenseTotal);
                    const isDifferent = total != invoiceTotal;
                    const style = isDifferent ? { color: 'red' } : {};
                    return (
                        <Tooltip title={isDifferent ? "Calculated Invoice Amount and Invoice Amount are Different" : ""}>
                        <span style={style}>
                            {typeof invoiceTotal === 'number' && !isNaN(invoiceTotal) ? '$' + invoiceTotal.toFixed(2) : invoiceTotal}
                        </span>
                        </Tooltip>
                    );
                }
            }
        },
        {
            name: "CostCenter",
            label: "Costcenter Number",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Owner",
            label: "Owner",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Email",
            label: "Owner Email",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "EmailGroup",
            label: "Email group",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "BillTo",
            label: "BillTo",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "ShipTo",
            label: "ShipTo",
            options: {
                filter: true,
                sort: true,
            }
        },
    
    ];
    
    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: 100,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
        onDownload: (buildHead, buildBody, columns, data) => {
        // Custom buildHead and buildBody functions
            const customBuildHead = () => {
                let newColumns = columns.map(column => column.label);
                return newColumns;
            }
        
            const customBuildBody = () => {
                const headers = customBuildHead();
                for (var i = 0; i < invoiceData.length; i++) {
                    let eachRow = data[i].data;
                    eachRow[1] =  moment.utc(eachRow[1]).format("MM/DD/YYYY");
                    eachRow[2] =  moment.utc(eachRow[2]).format("MM/DD/YYYY");
                    let total = getTotal(invoiceData[i])
                    eachRow[5] = total; // raw labor
                    eachRow[6] = eachRow[6] + "%";
                    eachRow[7] = applyDiscount(invoiceData[i], total); // discounted labor
                    
                    eachRow[9] = grandTotal(invoiceData[i], total, invoiceData[i].ExpenseTotal); // calculated total
                }
                return customBodyForExcelReport({data:data, headers:headers});
            };
            
            const headers = customBuildHead();
            const rows = customBuildBody();

            const selectedDate = moment.utc(month).format("yyyy-MM-DD");
            const filename = `MonthlyInvoiceReport.xlsx`;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet 1');
        
            const headerRow = worksheet.addRow(headers);
            headerRow.font = { bold: true };
        
            rows.forEach((row, rowIndex) => {
                const newRow = worksheet.addRow(Object.values(row));
        
                worksheet.columns.forEach((col, colIndex) => {
                    const headerLength = col.headers.length;
                    var maxColumnWidth = col.values.reduce((maxWidth, value) => {
                        if (value && value.length > maxWidth) {
                            return value.length;
                        }
                        return maxWidth;
                    }, 0);
                    if(maxColumnWidth>40){
                        maxColumnWidth=40
                    }

                    col.width = Math.max(headerLength, maxColumnWidth)+2;
                    col.alignment={ vertical: 'top', horizontal: 'left', wrapText: true }

                    if (invoiceData[rowIndex]) {
                        
						if (colIndex === 10 && newRow.getCell(colIndex).value != newRow.getCell(colIndex+1).value) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
                });
            });
        
            const currentDate = moment.utc().format("yyyy-MM-DD");
            // Generate the Excel file
            workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = currentDate + "_" + filename;
                a.click();
            });
            return false;
        }
    };
    
    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Invoice Monthly Report
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon/>
                        </IconButton>
                        <DialogTitle color="inherit">
                            Invoice Monthly Report
                        </DialogTitle>
                        <FormControlLabel
                            name="AllInvoices"
                            label="All Invoices"
                            style={{ color: 'white' }}
                            control={<Checkbox
	                        checked={showUnBilled}
	                        labelStyle={{ color: 'white' }}
	                        iconStyle={{ fill: 'white' }}
	                        inputStyle={{ color: 'white' }}
	                        style={{ color: 'white' }}
	                        onChange={e => { setShowUnBilled(!showUnBilled) }} /> }
                        />                       
                    </Toolbar>
                </AppBar>
                <DialogContent style={{ display: "flex", flexDirection: "row"}}>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-evenly"}}>
                            <DatePicker
                                label={'"Month" and "Year"'}
                                onChange={(newValue) => handleMonth(newValue)}
                                value={month}
                                views={['month', 'year']}
                            />
                            
                            <Button variant="contained" onClick={() => {handleGenerate(false);}} title='Click to Generate this report' sx={{margin: "15px" }}>
                                Generate
                            </Button>
                            <Button variant="contained" onClick={() => {handleGenerate(true);}} title='Click to Download this report' sx={{margin: "15px"}}>
                                Download
                            </Button>
                            
                            {/* <DownloadInvoiceMonthlyReport startDate={startDate} endDate={endDate} showUnBilled={showUnBilled ? "true" : "false"} /> */}
                        </div>
                    </MuiPickersUtilsProvider>
                </DialogContent>
            </Dialog>  
          <MuiThemeProvider theme={muiThemeDesign}>
            <Dialog open={openReport}  onClose={handleReportClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                 
                 <DialogContent >
                 <Box>
                    <MUIDataTable className="InvoiceMonthlyData"
                        title={
                            <Typography variant="h6" style={{ color: "white" }}>
                            <IconButton edge="start" color="inherit" onClick={handleReportClose} aria-label="close"> <CloseIcon /> </IconButton>
                                Beyondsoft Billed Invoice Monthly Report
                            </Typography>
                        }
                        data={isLoading ? [] :invoiceData}
                        columns={columns}
                        options={isLoading?muiLoaderOptions(options, isLoading):options}
                        
                    />
		        </Box>
		        </DialogContent>
              </Dialog> 
              <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="Invoice"
                aria-describedby="Invoice"
            >
                <DialogTitle id="Invoice">
                    {"Alert"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
             </MuiThemeProvider> 
        </div>
    );
}